export type ApprovalRole = 'rrhh' | 'supervisor' | 'manager';

export type LeaveApprovalConfig = {
    requiredApprovals: ApprovalRole[];
    description: string;
};


export const LEAVE_APPROVAL_CONFIG: LeaveApprovalConfig = {
    requiredApprovals: ['rrhh'], 
    description: 'Requiere aprobación de RRHH'
};

/**
 * Obtiene la configuración de aprobaciones para permisos
 */
export const getApprovalConfig = (): LeaveApprovalConfig => {
    return LEAVE_APPROVAL_CONFIG;
};

/**
 * Verifica si un permiso está completamente aprobado
 */
export const isLeaveApproved = (
    statusByRrhh: string,
    statusBySupervisor?: string,
    statusByManager?: string
): boolean => {
    const config = getApprovalConfig();
    const requiredApprovals = config.requiredApprovals;

    const statusMap: Record<ApprovalRole, string> = {
        rrhh: statusByRrhh,
        supervisor: statusBySupervisor || 'pending',
        manager: statusByManager || 'pending'
    };

    // Verificar que todos los roles requeridos hayan aprobado
    return requiredApprovals.every(role => statusMap[role] === 'approved');
};

/**
 * Verifica si un permiso está rechazado
 */
export const isLeaveRejected = (
    statusByRrhh: string,
    statusBySupervisor?: string,
    statusByManager?: string
): boolean => {
    const config = getApprovalConfig();
    const requiredApprovals = config.requiredApprovals;

    const statusMap: Record<ApprovalRole, string> = {
        rrhh: statusByRrhh,
        supervisor: statusBySupervisor || 'pending',
        manager: statusByManager || 'pending'
    };

    // Si alguno de los roles REQUERIDOS rechazó, el permiso está rechazado
    return requiredApprovals.some(role => statusMap[role] === 'rejected');
};